import React, {useState, useContext, useEffect} from "react";
import { UserContext } from '../../context/UserContext'
import { v4 as uuidv4 } from 'uuid';
import './QuestionRadio.css'

const QuestionRadio = ({ options, callback, currentAnswer }) => {
  const {
    getAnswers,
  } = useContext(UserContext);
  const answer = currentAnswer ? currentAnswer.answer : null;
  const findAnswer = getAnswers().find(i => i.answer === answer);
  const foundAnswer = findAnswer ? findAnswer.answer : '';
  
  const handleClick = (e) => {
    const answer = e.target.value;
    callback(answer);
  }

  const wrapClasses = 'col-span-12 wrap lg:col-span-6 form-group inline-block w-full sm:w-auto relative px-5 pb-3 bg-white p-2 pl-10 border-pinkish border rounded-xl ';
  const wrapClassesActive = 'active col-span-12 wrap lg:col-span-6 form-group inline-block w-full sm:w-auto relative px-5 pb-3 bg-white p-2 pl-10 border-pinkish border rounded-xl ';

  return (
    <>
      <p className={"text-gray text-size-12 line-height-12 uppercase hidden sm:block"} >Välj ett alternativ</p>
      <div className={"grid grid-cols-12 gap-y-4 gap-x-8"}>
        {options ? options.map( (item, i) => {
          return (
            <div id={ 'wrap-' + i } className={ item.option + ',' + item.value === foundAnswer ? wrapClassesActive : wrapClasses } key={uuidv4()}>
              <input
                type="radio" 
                id={ 'input-' + i } 
                name={ item.heading } 
                value={ item.option + ',' + item.value }
                data-value={item.value}
                data-index={i}
                onChange={handleClick}
                defaultChecked={ answer === item.option + ',' + item.value ? true : false }
              />

              <label
                className="text-xl sm:text-2xl font-medium pl-8 pr-5 text-black md:w-3/4 lg:w-4/5  text-grayish font-[500] text-size-13 " 
                htmlFor={ 'input-' + i }
              >
                <span className={"checkmark"}></span>
                {item.option}
              </label>
            </div>
          )
        }):null}
      </div>

      <span className={"mt-8 block text-size-12 text-grayish-2 block sm:hidden"}>{ 'Välj det alternativ som passar bäst' }</span>
    </>
  );
};

export default QuestionRadio;
